module.exports = __webpack_public_path__ + "img/shoppers-drugmart-logo.7f206c03.png";